
export default function Footer() {
  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Left Column - Brand */}
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-light mb-2 md:mb-3">Sarah Creates</h3>
            <p className="text-sm md:text-base text-stone-400 mb-6 md:mb-8">
              UGC Creator helping brands connect with their audience through authentic content.
            </p>
            
            <div className="flex items-center gap-3 md:gap-4">
              <a href="https://instagram.com/sarahcreates" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-stone-800 rounded-full flex items-center justify-center hover:bg-stone-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="https://tiktok.com/@sarahcreates" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-stone-800 rounded-full flex items-center justify-center hover:bg-stone-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-base md:text-lg"></i>
              </a>
              <a href="https://youtube.com/@sarahcreates" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-stone-800 rounded-full flex items-center justify-center hover:bg-stone-700 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-base md:text-lg"></i>
              </a>
              <a href="https://linkedin.com/in/sarahcreates" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-stone-800 rounded-full flex items-center justify-center hover:bg-stone-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-base md:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Quick Links */}
          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-xs uppercase tracking-wider text-stone-500 mb-4 md:mb-6">
              Quick Links
            </h4>
            <div className="space-y-3 md:space-y-4">
              <a href="#portfolio" className="block text-sm md:text-base text-stone-300 hover:text-white transition-colors cursor-pointer">
                Portfolio
              </a>
              <a href="#about" className="block text-sm md:text-base text-stone-300 hover:text-white transition-colors cursor-pointer">
                Services
              </a>
              <a href="#contact" className="block text-sm md:text-base text-stone-300 hover:text-white transition-colors cursor-pointer">
                Pricing
              </a>
              <a href="#contact" className="block text-sm md:text-base text-stone-300 hover:text-white transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          </div>

          {/* Right Column - Contact */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-wider text-stone-500 mb-4 md:mb-6">
              Get in Touch
            </h4>
            <div className="space-y-3 md:space-y-4">
              <a href="mailto:hello@sarahcreates.com" className="flex items-center gap-2 md:gap-3 text-sm md:text-base text-stone-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                <span>hello@sarahcreates.com</span>
              </a>
              <div className="flex items-center gap-2 md:gap-3 text-sm md:text-base text-stone-300">
                <i className="ri-map-pin-line"></i>
                <span>Los Angeles, CA</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-sm md:text-base text-stone-300">
                <i className="ri-time-line"></i>
                <span>24-48h response time</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs md:text-sm text-stone-500">
            <div className="text-center md:text-left">
              © 2025 Sarah Creates. All rights reserved.
            </div>
            
            <div className="flex items-center gap-4 md:gap-6">
              <a href="#privacy" className="hover:text-stone-300 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#terms" className="hover:text-stone-300 transition-colors cursor-pointer">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
